import { NessOutboundF } from '../../../../Ness/Outbound/F/Function/module/NessOutboundF.js';

const executeIsSignedInMap = {
  NESS: () => {
    return window.box.sel('is_user->id') && window.box.sel('is_user->type') != 'TEMP';
  },
  // TODO 따로 하나 만들어야 할 것 같습니다 @jhj
  MARPPLE_SHOP: () => {
    return window.box.sel('is_user->id') && window.box.sel('is_user->type') != 'TEMP';
  },
};

export const isSignedIn = () => {
  if (!G.MARKETPLACE_NAME) return void 0;
  return executeIsSignedInMap?.[G.MARKETPLACE_NAME]();
};

const executeGoSignInMap = {
  NESS: () => {
    return (location.href = `/${T.lang}/@/login?url=${location.pathname + location.search}`);
  },
  // TODO 따로 하나 만들어야 할 것 같습니다 @jhj
  MARPPLE_SHOP: () => {
    return (location.href = `/${T.lang}/@/login?url=${location.pathname + location.search}`);
  },
};

export const goSignIn = () => {
  if (!G.MARKETPLACE_NAME) return void 0;
  return executeGoSignInMap?.[G.MARKETPLACE_NAME]();
};

const executeGoSignUpMap = {
  NESS: NessOutboundF.goSignUp,
  // TODO 따로 하나 만들어야 할 것 같습니다 @jhj
  MARPPLE_SHOP: () => {
    return (location.href = `/${T.lang}/@/login?is_join=true&url=${location.pathname + location.search}`);
  },
};

export const goSignUp = () => {
  if (!G.MARKETPLACE_NAME) return void 0;
  return executeGoSignUpMap?.[G.MARKETPLACE_NAME]();
};
